export const getCaseStudies = (state) => (state.caseStudies.caseStudies);
export const getCaseStudy = (state) => (
  state.caseStudies.caseStudy
);
export const getErrorMessage = (state) => (state.caseStudies.errorMessage);
